import { Action, createReducer, on } from '@ngrx/store';
import * as translationActions from '../actions/translation.actions';
import { TranslationData } from '../../interfaces/translation.interface';

export const translationFeatureKey = 'translation';

export interface State {
    defaultFileTranslation: TranslationData;
    fileTranslation: TranslationData;
}

export const initialState: State = {
    defaultFileTranslation: null,
    fileTranslation: null
};

const translationReducer = createReducer(
    initialState,
    on(translationActions.getDefaultFileTranslationSuccess, (state, { translation }) => ({
        ...state,
        defaultFileTranslation: translation
    })),
    on(translationActions.getFileTranslationSuccess, (state, { translation }) => ({
        ...state,
        fileTranslation: translation
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return translationReducer(state, action);
}
